import { ShieldCheck, MessageCircle } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { WA_FLOAT } from "@/lib/constants";

const CONVENIOS = [
  { name: "CAAPI", full: "Caixa de Assistência da Advocacia Piauiense", logo: "/convenios/caapi.png" },
  { name: "IASPI", full: "Instituto de Assistência à Saúde dos Servidores Públicos do Estado do Piauí", logo: "/convenios/iaspi.png" },
  { name: "IPMT Saúde", full: "Instituto de Previdência do Município de Teresina", logo: "/convenios/ipmt.png" },
];

export const Convenios = () => (
  <section id="convenios" data-testid="convenios-section" className="bg-white py-20 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        center
        overline="Convênios"
        title="Mais acesso à sua saúde"
        text="Aceitamos os principais convênios. Veja se o seu está na lista:"
      />

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
        {CONVENIOS.map((c, i) => (
          <Reveal key={c.name} delay={i * 0.1} className="h-full">
            <div
              data-testid={`convenio-card-${c.name.toLowerCase().replace(/\s/g, "-")}`}
              className="group flex h-full flex-col items-center justify-center rounded-2xl border border-cob-light/80 bg-white px-8 py-10 text-center shadow-[0_10px_35px_-18px_rgba(6,63,50,0.18)] transition-all duration-500 hover:-translate-y-1.5 hover:border-cob-gold/50 hover:shadow-[0_24px_45px_-20px_rgba(6,63,50,0.3)]"
            >
              <div className="flex h-24 w-full items-center justify-center">
                <img loading="lazy" decoding="async"
                  src={c.logo}
                  alt={`Convênio ${c.name}`}
                  className="max-h-full max-w-full object-contain transition-transform duration-500 group-hover:scale-[1.06]"
                />
              </div>
              <p className="mt-5 text-[12px] font-medium leading-relaxed text-cob-muted">{c.full}</p>
              <span className="mt-4 block h-px w-8 bg-cob-gold/60 transition-all duration-500 group-hover:w-14" />
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.25}>
        <div className="mt-10 flex flex-col items-center gap-3 text-center">
          <p className="inline-flex items-center gap-2 text-sm text-cob-muted">
            <ShieldCheck className="h-4.5 w-4.5 text-cob-gold" />
            Não encontrou o seu convênio? Fale com a gente.
          </p>
          <a
            href={WA_FLOAT}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="convenios-cta-whatsapp"
            className="btn-press inline-flex items-center gap-2.5 rounded-full bg-cob-green px-8 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-cob-dark hover:shadow-[0_16px_35px_-12px_rgba(6,63,50,0.5)]"
          >
            <MessageCircle className="h-4.5 w-4.5" />
            Consultar convênio pelo WhatsApp
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
